var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{on:{"click":function($event){_vm.$emit('click')}}},[_c('td',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.appointments))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.sold))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$n(_vm.revenue, 'money')))]),_vm._v(" "),_c('td',{class:{'is-warning': _vm.isWarning}},[_c('strong',[_vm._v(_vm._s(_vm.conversionText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3246865c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/sellers/SellerRow.vue
// module id = 777
// module chunks = 1